<div class="loading" #divContainer>
  <h1>{{text}}</h1>
</div>